/**
 * Scales down an image to fit within maxSize while maintaining aspect ratio
 * Returns the original image if it's already smaller than maxSize
 * @param {p5.Image} img - The image to scale
 * @param {number} maxSize - Maximum width or height in pixels
 * @returns {p5.Image} - The scaled image
 */
export function scaleImageDown(img, maxSize) {
  const maxDim = Math.max(img.width, img.height);

  // If image is already small enough, return it as-is
  if (maxDim <= maxSize) {
    return img;
  }

  // Calculate new dimensions maintaining aspect ratio
  const scale = maxSize / maxDim;
  const newWidth = Math.floor(img.width * scale);
  const newHeight = Math.floor(img.height * scale);

  // Create a temporary graphics buffer for resizing
  const tempBuffer = createGraphics(newWidth, newHeight);
  tempBuffer.image(img, 0, 0, newWidth, newHeight);

  // Convert buffer to p5.Image
  const scaledImage = tempBuffer.get();

  // Clean up
  tempBuffer.remove();

  return scaledImage;
}